export default {
  UGCP: "यूजीसीपी",
  BLOCK: "ब्लॉक",
  REPORT: "रिपोर्ट",
};
